import { Allegato } from "./attachment";

export class Juror {
	idJuror?: string;
	nome: string;
	cognome: string;
	email: string;
	telefono: string;
	indirizzoDomicilio: string;
	idOrganismo: string;
	idCanaleEdizione: string;
	idCategoriaEdizione: string;
	note: string;
	inMailingList: boolean;
	titolo: string;
	allegati: Allegato[];
	captchaResponse?: string;

	constructor() {
		this.inMailingList = true;
		this.allegati = new Array();
		this.allegati.push(new Allegato("Curriculum Vitae"));
		this.allegati.push(new Allegato("Profile photo"));
	}
}

export interface CreazioneUtenteResponse {
	tokenSMS: string;
	esito: number;
	descrizione:string;
}
